import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { AchievementService } from 'src/app/services/achievement.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { JournalService } from 'src/app/services/journal.service';
import { UserEatWellService } from 'src/app/services/user-eat-well.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';

@Component({
  selector: 'app-eat-well-index',
  templateUrl: './eat-well-index.component.html',
  styleUrls: ['./eat-well-index.component.scss'],
})
export class EatWellIndexComponent implements OnInit {
  isLoading = false;
  userData: any;
  allEntries: any;
  eatWellWeekData: any;
  weekScore = 0;
  allTaskStatuses: any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();

  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    private userEatWellService: UserEatWellService,
    private userTaskStatusService: UserTaskStatusService,
    public journalService: JournalService,
    private achievementService: AchievementService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.achievementService.refreshNotifications();
        this.isLoading = false;
      }
    });

    forkJoin({
      allEntries: this.userEatWellService.fetchAll(),
      allUserTaskStatuses: this.userTaskStatusService.fetchAll(),
    }).subscribe(
      (responseData) => {
        this.allEntries = responseData.allEntries;

        this.eatWellWeekData = this.userEatWellService.generateWeekArray(
          this.currentWeek,
          this.allEntries
        );

        this.weekScore = this.userEatWellService.getWeekScore(
          this.eatWellWeekData
        );
        this.allTaskStatuses = responseData.allUserTaskStatuses;
        let readResources = this.userTaskStatusService.checkTaskStatus(
          this.allTaskStatuses,
          'EatWellIntro'
        );
        if (!readResources) {
          this.router.navigate(['/modules', 'eat-well', 'resources']);
        }
        this.isLoading = false;
      },
      (error) => {}
    );
  }
}
